import { createContext } from 'react';
import { TransactionStepper } from 'src/types';

export const WithdrawStepContext = createContext<TransactionStepper>(
  {} as TransactionStepper
);

export const WithdrawStepProvider = WithdrawStepContext.Provider;
